import { render } from "./garmentDetail.vue?vue&type=template&id=2bf156c8&ts=true"
import script from "./garmentDetail.vue?vue&type=script&lang=ts"
export * from "./garmentDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__